import dashboard from '../assets/dashboard.png';

function StaticDashboard() {
  return (
    <div>
      <img src={dashboard} width={1000} alt="_image" />
    </div>
  );
}

export default StaticDashboard;
